import type { UseFormReturn } from 'react-hook-form'
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from '@/components/ui/form'
import { Switch } from '@/components/ui/switch'

interface FeatureSettingsProps {
  form: UseFormReturn<any>
}

export function FeatureSettings({ form }: FeatureSettingsProps) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-2">Feature Toggles</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Enable or disable Maater features.
        </p>
        
        <div className="space-y-4">
          <FormField
            control={form.control}
            name="features.voiceMemos"
            render={({ field }) => (
              <FormItem className="flex items-center justify-between">
                <div className="space-y-0.5">
                  <FormLabel>Voice Memos</FormLabel>
                  <FormDescription>
                    Enable voice memo recording and transcription
                  </FormDescription>
                </div>
                <FormControl>
                  <Switch
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                </FormControl>
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="features.aiSuggestions"
            render={({ field }) => (
              <FormItem className="flex items-center justify-between">
                <div className="space-y-0.5">
                  <FormLabel>AI Suggestions</FormLabel>
                  <FormDescription>
                    Enable AI-powered suggestions and autocomplete
                  </FormDescription>
                </div>
                <FormControl>
                  <Switch
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                </FormControl>
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="features.semanticSearch"
            render={({ field }) => (
              <FormItem className="flex items-center justify-between">
                <div className="space-y-0.5">
                  <FormLabel>Semantic Search</FormLabel>
                  <FormDescription>
                    Enable AI-powered semantic search across documents
                  </FormDescription>
                </div>
                <FormControl>
                  <Switch
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
      </div>
    </div>
  )
}

